<template>
  <b-modal
    id="my-modal"
    hide-footer
    hide-header
    no-close-on-backdrop
    no-close-on-esc
    centered
  >
    <div class="row">
      <div class="col-4 col-sm-5 lhs-img"></div>
      <div class="col-8  col-sm-7 bg-brand-dark-green">
        <div class="col-12 mx-auto py-3">
          <img
            src="../assets/images/logo-white.svg"
            alt=""
            srcset=""
            class="img-fluid"
            style="width: 15rem;"
          />
          <h3 class="text-white font-weight-bold font-18 py-4">
            Select your region and language
          </h3>
          <cookie-section :varient="'modal-cookie'" />
        </div>
        <div
          class="d-flex justify-content-between align-items-center px-4 pb-4 float-right mt-3"
        >
          <my-button
            @click="saveValue()"
            :trackEventLink="{
              event: 'form',
              name: 'onclick',
              action: 'click',
              type: 'click',
              region: 'main content',
              section: 'select your region and language',
              text: 'continue',
              user_geo_region: $store.state.Dregion.toLocaleLowerCase(),
              language: $store.state.Dlanguage.toLocaleLowerCase()
            }"
            type="button"
            varient="outline-white-inverted"
            reference="javascript:void(0)"
            class="font-12 stb-sBold"
            >Continue</my-button
          >
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
import myButton from './base-button'
import cookieSection from './cookieSection'
export default {
  components: {
    cookieSection,
    myButton
  },
  mounted() {
    // check for region on the url if it exists store it else trigger the modal
    if (
      this.$route.query.region &&
      this.$store.state.signInUrls[this.$route.query.region]
    ) {
      this.$store.state.Dlanguage = 'en'
      this.$store.state.Dregion = this.$route.query.region
      this.saveValue()
    } else if (!this.$cookies.get('TBW') && this.$route.path!=='/coffee-academy/videos') {
      console.log(this.$route.name)
      this.$bvModal.show('my-modal')
    }
  },
  methods: {
    saveValue() {
      // TODO: when user clicks on continue store the region and language value available in the
      const preferences = {
        language: this.$store.state.Dlanguage,
        region: this.$store.state.Dregion
      }
      this.$cookies.set('TBW', preferences)
      this.$bvModal.hide('my-modal')
    }
  }
}
</script>

<style lang="scss" scoped>
.lhs-img {
  min-height: 320px;
  background-image: url('../assets/images/modal-image.png');
  background-position: center;
  background-size: cover;
}
.modal-skip {
  color: rgba(255, 255, 255, 0.404);
}
</style>
